import React from 'react';
import { BANCOS_CONFIG } from '../../constants/bancos';

export default function SeletorBancos({ taxasSelecionadas, setTaxasSelecionadas }) {
  const toggleBanco = (banco, valor) => {
    setTaxasSelecionadas((prev) => {
      const next = { ...prev };
      if (next[banco] === valor) delete next[banco];
      else next[banco] = valor;
      return next;
    });
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
        }}
      >
        <span
          style={{
            fontSize: '0.75rem',
            fontWeight: 600,
            color: 'var(--text-muted)',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
          }}
        >
          Selecione bancos e taxas
        </span>
        {Object.keys(taxasSelecionadas).length > 0 && (
          <button
            onClick={() => setTaxasSelecionadas({})}
            style={{
              fontSize: '0.7rem',
              color: 'var(--danger)',
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.2)',
              borderRadius: 6,
              padding: '3px 8px',
              cursor: 'pointer',
              fontFamily: 'var(--font)',
              fontWeight: 600,
            }}
          >
            Limpar
          </button>
        )}
      </div>

      {BANCOS_CONFIG.map((banco) => {
        const isSelected = banco.banco in taxasSelecionadas;
        return (
          <div key={banco.banco} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <img
                src={banco.logo}
                alt={banco.banco}
                style={{
                  width: 22,
                  height: 22,
                  objectFit: 'contain',
                  borderRadius: 4,
                  background: '#fff',
                  padding: 2,
                  border: '1px solid var(--border)',
                }}
              />
              <span
                style={{
                  fontWeight: 600,
                  fontSize: '0.82rem',
                  color: isSelected ? 'var(--text)' : 'var(--text-muted)',
                }}
              >
                {banco.banco}
              </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, paddingLeft: 30 }}>
              {banco.opcoes.map((op) => {
                const active = taxasSelecionadas[banco.banco] === op.valor;
                return (
                  <button
                    key={op.valor}
                    onClick={() => toggleBanco(banco.banco, op.valor)}
                    style={{
                      padding: '5px 10px',
                      borderRadius: 'var(--radius-xs)',
                      border: active ? '1.5px solid var(--accent)' : '1.5px solid var(--border)',
                      background: active ? 'rgba(0,214,143,0.06)' : 'var(--surface)',
                      color: active ? 'var(--text)' : 'var(--text-muted)',
                      fontSize: '0.72rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontFamily: 'var(--font)',
                      transition: 'all 0.15s',
                    }}
                  >
                    {op.label} — {op.valor}%
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}